module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"学生・卒業生 ログイン画面","description":"学校関係者様、採用担当者様はこの画面からの会員登録はできません。","sign_up":"会員登録(無料)","sign_in":"ログイン","for_school":"学校関係者様はこちら","for_corporate":"採用担当者様はこちら"}}')
  delete Component.options._Ctor
}
